import React from "react";

export interface CanvasRootProps {
  width?: number;
  height?: number;
  children?: React.ReactNode;
}

export const CanvasRoot: React.FC<CanvasRootProps> = ({ width = 800, height = 450, children }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Learning visualization"
      style={{ width: "100%", height: "auto", display: "block" }}
    >
      {children}
    </svg>
  );
};
